<template>
  <div id="placeholder" style="width: 100%; height: 100%">
    <iframe
      :src="fileUrl"
      frameborder="0"
      style="width: 100%; height: 100%"
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([]),
  },
  data() {
    return {
      fileUrl: "",
    };
  },
  created() {
    this.fileUrl = sessionStorage.getItem("previewurl");
    sessionStorage.removeItem("previewurl");
  },
  mounted() {},
};
</script>

<style scoped></style>
